import { loadStripe } from '@stripe/stripe-js'
import config from 'config/api/Config'
import { logError } from 'config/lib/errorLib'

// Lazy, memoised Stripe loader.
//
// We intentionally do NOT call loadStripe() at module import time. Doing so
// triggered a network request to js.stripe.com on every page load (including
// /login), and when that request failed (ad blockers, corporate firewalls,
// flaky networks) the resulting promise rejection was unhandled and reported
// to Sentry as "Failed to load Stripe.js".
//
// By deferring the call until a component actually needs Stripe, and by
// attaching a .catch so the rejection is always handled, we avoid the noisy
// Sentry reports without changing behaviour for users who do reach a payment
// screen — <Elements> still receives the same promise and will surface a
// real error if Stripe truly cannot load.

let stripePromise = null

export function getStripePromise() {
    if (stripePromise === null) {
        stripePromise = loadStripe(config.stripeKey).catch((err) => {
            // Swallow the rejection so it isn't reported as an unhandled
            // promise rejection. Log it instead for visibility. Reset the
            // cache so a later attempt can retry.
            logError(err)
            stripePromise = null
            return null
        })
    }
    return stripePromise
}
